import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  ErrorMessage,
  ImageDiv,
  ImageDivText,
  InputContainer,
  InputContainer1,
  InputDiv,
  InputDiv1,
  InputFieldDiv,
  InputLevel,
} from "./Volunteer.style";
import { Box, IconButton, MenuItem, TextField, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { PhotoCamera } from "@mui/icons-material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { handleEditClose } from "../../redux/Reducer/ModalSlice";
import { ApprovedButton, ThemButton } from "../Login/Login.style";
import { useQuery } from "@tanstack/react-query";
import SyncLoader from "react-spinners/SyncLoader";
import { toast, ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useAllVolunteer from "../../hooks/useAllVolunteer";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import StyledInput from "../Share/StyledInput";
import { yupResolver } from "@hookform/resolvers/yup";
import schema from "./ValidationEdit";

const VolunteerEdit = () => {
  const dispatch = useDispatch();
  const [selectedImage, setSelectedImage] = useState();
  const [isLoading, setIsLoading] = useState();
  const [selectedImageNid, setSelectedImageNid] = useState();

  const [division, setDivision] = useState([]);
  const [divisionId, setDivisionId] = useState("");
  const [district, setDistrict] = useState([]);
  const [districtId, setDistrictId] = useState("");
  const [thana, setThana] = useState([]);
  const userId = localStorage.getItem("uI");
  const user_id = userId - 786;
  const volunteerData = useSelector((state) => state.Modal.val);

  const availabilitys = volunteerData.availability;
  const medicalHistorys = volunteerData.medical_history === "Y" ? "Y" : "N";
  const first_attachment_types = volunteerData.first_attachment_type;

  const second_attachment_types = volunteerData.second_attachment_type;

  const participatedClinicalTrials = volunteerData.previous_clinic_trial;

  const [allVolunteerInfo, , isError, error, isSuccess, refetch] =
    useAllVolunteer();

  // const { data: volunteerInformationData = [] } = useQuery({
  //   queryKey: ["volunteerInformationData"],
  //   queryFn: async () => {
  //     const res = await fetch(
  //       `${process.env.REACT_APP_API_URL}/api/voluntaryInformatinById/${volunteerData.vol_no}`
  //     );
  //     const data = await res.json();
  //     setVolData(data);
  //     return data;
  //   },
  // });

  const [female, setFemale] = useState(volunteerData?.sex);
  const [isMedicalHistory, setIsMedicalHistory] = useState();
  const [isAvailability, setIsAvailability] = useState();

  const [isParticipatedClinicalTrials, setIsParticipatedClinicalTrials] =
    useState();
  const [isCOVID, setIsCOVID] = useState();
  const [isFatherOrHusbandNID, setIsFatherOrHusbandNID] = useState();
  const [selectedImageCOVID, setSelectedImageCOVID] = useState();
  const [selectedImageFatherOrHusbandNID, setSelectedImageFatherOrHusbandNID] =
    useState();

  const ApproveStatusToggle = useSelector((state) => state.Modal.val1);

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const handleFemale = (e) => {
    const selectValue = e.target.value;
    setFemale(selectValue === "Female");
  };
  const handleMedicalHistory = (e) => {
    const selectValue = e.target.value;
    setIsMedicalHistory(selectValue === "Y");
  };
  const handleAvailability = (e) => {
    const selectValue = e.target.value;
    setIsAvailability(selectValue === "Y");
  };
  const handleParticipatedClinicalTrials = (e) => {
    const selectValue = e.target.value;
    setIsParticipatedClinicalTrials(selectValue === "Y");
  };
  const handleCOVID = (e) => {
    const selectValue = e.target.value;
    setIsCOVID(selectValue === "C");
  };

  const handleFatherOrHusbandNID = (e) => {
    const selectValue = e.target.value;
    setIsFatherOrHusbandNID(selectValue === "F");
  };

  const imageChangeCOVID = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImageCOVID(e.target.files[0]);
    }
  };
  const imageChangeFatherOrHusbandNID = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImageFatherOrHusbandNID(e.target.files[0]);
    }
  };

  useEffect(() => {
    const getDivision = async () => {
      const resDivision = await fetch(
        `${process.env.REACT_APP_API_URL}/api/divisionList`
      );
      const resDiv = await resDivision.json();
      setDivision(await resDiv);
    };
    getDivision();
  }, []);

  const handleDivision = (event) => {
    const getDivisionId = event.target.value;
    setDivisionId(getDivisionId);
  };

  // district list
  useEffect(() => {
    const getDistrict = async () => {
      const resDistrict = await fetch(
        `${process.env.REACT_APP_API_URL}/api/districtList/${volunteerData.pr_city}`
      );
      const resDis = await resDistrict.json();
      setDistrict(await resDis);
    };
    getDistrict();
  }, []);

  useEffect(() => {
    if (divisionId) {
      const getDistrict = async () => {
        const resDistrict = await fetch(
          `${process.env.REACT_APP_API_URL}/api/districtList/${divisionId}`
        );
        const resDis = await resDistrict.json();
        setDistrict(await resDis);
      };
      getDistrict();
    }
  }, [divisionId]);

  const handleDistrict = (event) => {
    const getDistrictId = event.target.value;
    setDistrictId(getDistrictId);
  };

  useEffect(() => {
    const getThana = async () => {
      const resThana = await fetch(
        `${process.env.REACT_APP_API_URL}/api/thanaList/${volunteerData.permanent_district}`
      );
      const resTh = await resThana.json();
      setThana(await resTh);
    };
    getThana();
  }, []);

  useEffect(() => {
    if (districtId) {
      const getThana = async () => {
        const resThana = await fetch(
          `${process.env.REACT_APP_API_URL}/api/thanaList/${districtId}`
        );
        const resTh = await resThana.json();
        setThana(await resTh);
      };
      getThana();
    }
  }, [districtId]);

  const { data: occupationInfo = [] } = useQuery({
    queryKey: ["occupationInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/occupationDropdown`
      );
      const data = await res.json();
      return data;
    },
  });

  const approve =
    volunteerData.national_id != null &&
    volunteerData.approved_status === 0 &&
    volunteerData.national_id != "" &&
    ApproveStatusToggle !== "1" &&
    volunteerData.active_fg == "1";

  const approveMethod = () => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/voluntaryApproving/${volunteerData.vol_no}`,

      {
        method: "GET",
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.success === false && data.age_valid === "low") {
          toast.error("Not Approve. Volunteer age under 18!", {
            position: toast.POSITION.TOP_CENTER,
          });
        } else if (data.success === false && data.age_valid === "high") {
          toast.error("Not Approve. Volunteer age over 55!", {
            position: toast.POSITION.TOP_CENTER,
          });
        } else if (data.success === true && data.age_valid === "ok") {
          toast.success("Volunteer Approve.", {
            position: toast.POSITION.TOP_CENTER,
          });
          refetch().then(() => {
            dispatch(handleEditClose());
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    // .finally(() => setIsLoadingApprove(false));
  };

  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImage(e.target.files[0]);
    }
  };

  const removeSelectedImage = () => {
    setSelectedImage();
  };
  const removeSelectedImageCOVID = () => {
    setSelectedImageCOVID();
  };
  const removeSelectedImageFatherOrHusbandNID = () => {
    setSelectedImageFatherOrHusbandNID();
  };
  const imageChangeNid = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImageNid(e.target.files[0]);
    }
  };

  const removeSelectedImageNid = () => {
    setSelectedImageNid();
  };

  const { data: proInfo = [] } = useQuery({
    queryKey: ["proInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/proNameList`
      );
      const volData = await res.json();
      const data = await volData.data;
      return data;
    },
  });

  const onSubmit = (data, e) => {
    // alert(JSON.stringify(data));
    setIsLoading(true);

    const reg1 = data?.dor;
    const dateObj = new Date(reg1);
    const dateStr = dateObj.toLocaleDateString("en-CA");
    const reg2 = data?.dob;
    const dateObj1 = new Date(reg2);
    const dateStr1 = dateObj1.toLocaleDateString("en-CA");

    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("vol_no", volunteerData.vol_no);
    formData.append("voluntary_image", selectedImage);
    formData.append("voluntary_nid_image", selectedImageNid);
    formData.append(
      "date_of_registration",
      dateStr || volunteerData.date_of_registration
    );
    formData.append("full_name", data.full_name);
    formData.append("vol_initial", data.vol_initial);
    formData.append("father_name", data.father_name);
    formData.append("email", data.email);
    formData.append("sex", data.sex);
    formData.append("v_fathr_or_husb_name", data.v_fathr_or_husb_name);
    formData.append("fathr_or_husb_nid", data.fathr_or_husb_nid);
    formData.append("mother_name", data.mother_name);
    formData.append("marital_status", data.marital_status);
    formData.append("dob", dateStr1 || volunteerData.dob);
    formData.append("vol_blood_group", data.vol_blood_group);
    formData.append("nationality", data.nationality);
    formData.append("occupation_name", data.occupation_name);
    formData.append("national_id", data.national_id);
    formData.append("contact_phone", data.contact_phone);

    //new add
    formData.append("email", data.email);
    formData.append("medical_history", data.medical_history);
    formData.append("health_condition", data.health_condition);
    formData.append("previous_illness", data.previous_illness);
    formData.append("surgery_history", data.surgery_history);
    formData.append("curr_medication", data.curr_medication);
    formData.append("allergies", data.allergies);

    formData.append("availability", data.availability);
    formData.append("previous_clinic_trial", data.previous_clinic_trial);
    formData.append("pre_clin_trial_detail", data.pre_clin_trial_detail);

    formData.append("covid_title", data.covid_title);
    formData.append("covid_desc", data.covid_desc);
    formData.append("covid_image", selectedImageCOVID);
    formData.append("attachment_type_covid", data.covid);
    formData.append("fathr_or_husb_nid_title", data.fathr_or_husb_nid_title);
    formData.append("fathr_or_husb_nid_desc", data.fathr_or_husb_nid_desc);
    formData.append("attachment_type_nid", data.fatherOrHusbandNID);

    formData.append("fathr_or_husb_nid_image", selectedImageFatherOrHusbandNID);

    formData.append("pr_city", divisionId || volunteerData.pr_city);
    formData.append(
      "permanent_district",
      districtId || volunteerData.permanent_district
    );
    formData.append("thana_id", data.thana_id);
    formData.append("permanent_postoffice", data.permanent_postoffice);
    formData.append("village_name", data.village_name);
    formData.append("pro_id", data.pro_id);
    formData.append("old_vol_id", data.old_vol_id);
    formData.append("emergency_contract_ph", data.emergency_contract_ph);
    formData.append("emergency_contract_nm", data.emergency_contract_nm);
    formData.append(
      "contact_contract_relation",
      data.contact_contract_relation
    );
    formData.append("reg_no", data.reg_no);
    formData.append("active_fg", data.active_fg);
    fetch(`${process.env.REACT_APP_API_URL}/api/updateVoluntary`, {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.success === true) {
          toast.success("Volunteer update successful!.", {
            position: toast.POSITION.TOP_CENTER,
          });
          refetch().then(() => {
            dispatch(handleEditClose());
          });
        } else {
          toast.error(
            "Oops! There was an issue updating the volunteer information.",
            {
              position: toast.POSITION.TOP_CENTER,
            }
          );
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <InputFieldDiv>
          <InputDiv>
            <InputContainer style={{ height: "1rem" }}></InputContainer>
            <InputContainer1>
              <InputLevel>Date of Registration</InputLevel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                  name="dor"
                  control={control}
                  defaultValue={volunteerData?.date_of_registration}
                  render={({ field }) => (
                    <>
                      <DesktopDatePicker
                        maxDate={new Date()}
                        inputFormat="DD MMM YYYY"
                        value={field.value}
                        onChange={(date) => field.onChange(date)}
                        renderInput={(params) => (
                          <TextField fullWidth size="small" {...params} />
                        )}
                      />
                      {errors.dor && (
                        <ErrorMessage>{errors.dor.message}</ErrorMessage>
                      )}
                    </>
                  )}
                />
              </LocalizationProvider>
            </InputContainer1>

            <InputDiv1>
              <TextField
                size="small"
                fullWidth
                label="Name*"
                variant="outlined"
                defaultValue={volunteerData?.full_name}
                {...register("full_name")}
              />
              {errors.full_name && (
                <ErrorMessage>{errors.full_name.message}</ErrorMessage>
              )}
            </InputDiv1>

            <InputDiv1>
              <TextField
                size="small"
                fullWidth
                label="Registration Number"
                variant="outlined"
                defaultValue={volunteerData?.reg_no}
                {...register("reg_no")}
              />
            </InputDiv1>

            <InputDiv1>
              <TextField
                size="small"
                fullWidth
                label="Father Name"
                variant="outlined"
                defaultValue={volunteerData?.father_name}
                {...register("father_name")}
              />
              {errors.father_name && (
                <ErrorMessage>{errors.father_name.message}</ErrorMessage>
              )}
            </InputDiv1>

            <InputDiv1>
              <TextField
                size="small"
                fullWidth
                label="Mother Name"
                defaultValue={volunteerData?.mother_name}
                variant="outlined"
                {...register("mother_name")}
              />
            </InputDiv1>

            <InputDiv1>
              <TextField
                select
                fullWidth
                size="small"
                label="Marital Status*"
                defaultValue={volunteerData?.marital_status}
                {...register("marital_status")}
              >
                <MenuItem value="Unmarried">Unmarried</MenuItem>
                <MenuItem value="Married">Married</MenuItem>
              </TextField>
              {errors.marital_status && (
                <ErrorMessage>{errors.marital_status.message}</ErrorMessage>
              )}
            </InputDiv1>
          </InputDiv>

          <InputDiv
            style={{
              maxHeight: "500px",
              lineHeight: "21px",
              padding: "8px 0px 0px 24px",
            }}
          >
            <ImageDivText
              style={{ padding: "6px 0px 0px 12px", marginBottom: ".75rem" }}
            >
              Volunteer image (Upload)
            </ImageDivText>

            <ImageDiv
              style={{
                height: "160px",
              }}
            >
              {!selectedImage && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                    width: "100%",
                    gap: ".2rem",
                  }}
                >
                  <div
                    style={{
                      alignItem: "center",
                      justifyContent: "center",
                      marginTop: "1.5rem",
                    }}
                  >
                    <Tooltip title="Upload image here">
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="label"
                      >
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={imageChange}
                        />
                        <PhotoCamera />
                      </IconButton>
                    </Tooltip>
                  </div>

                  <div
                    style={
                      volunteerData?.voluntary_image
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <img
                      style={{
                        height: "120px",
                        maxWidth: "200px",
                      }}
                      src={volunteerData?.voluntary_image}
                      alt=""
                    />
                  </div>
                </div>
              )}

              {selectedImage && (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 4fr 1fr",
                    gap: ".2rem",
                  }}
                >
                  <div
                    style={{
                      alignItem: "center",
                      justifyContent: "center",
                      marginTop: "1.5rem",
                    }}
                  >
                    <Tooltip title="Upload image here">
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="label"
                      >
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={imageChange}
                        />
                        <PhotoCamera />
                      </IconButton>
                    </Tooltip>
                  </div>

                  <div style={{}}>
                    <img
                      style={{
                        height: "120px",
                        maxWidth: "200px",
                      }}
                      src={URL.createObjectURL(selectedImage)}
                      alt="Thumb"
                    />
                  </div>
                  <div
                    style={{
                      alignItem: "center",
                      justifyContent: "center",
                      marginTop: "1.5rem",
                    }}
                  >
                    <Tooltip title="Remove this image here">
                      <IconButton onClick={removeSelectedImage}>
                        <HighlightOffIcon
                          sx={{
                            color: "#3490DC",
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              )}
            </ImageDiv>

            <ImageDivText
              style={{ padding: "6px 0px 0px 12px", margin: " .25rem 0" }}
            >
              NID/Passport/Birth Certificate Image (Upload)
            </ImageDivText>

            <ImageDiv
              style={{
                height: "160px",
              }}
            >
              {!selectedImageNid && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                    width: "100%",
                    gap: ".2rem",
                  }}
                >
                  <div
                    style={{
                      alignItem: "center",
                      justifyContent: "center",
                      marginTop: "1.5rem",
                    }}
                  >
                    <Tooltip title="Upload image here">
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="label"
                      >
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={imageChangeNid}
                        />
                        <PhotoCamera />
                      </IconButton>
                    </Tooltip>
                  </div>

                  <div
                    style={
                      volunteerData?.voluntary_nid_image
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <img
                      style={{
                        height: "120px",
                        maxWidth: "200px",
                      }}
                      src={volunteerData?.voluntary_nid_image}
                      alt=""
                    />
                  </div>
                </div>
              )}

              {selectedImageNid && (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 4fr 1fr",
                    gap: ".2rem",
                  }}
                >
                  <div
                    style={{
                      alignItem: "center",
                      justifyContent: "center",
                      marginTop: "1.5rem",
                    }}
                  >
                    <Tooltip title="Upload image here">
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="label"
                      >
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={imageChangeNid}
                        />
                        <PhotoCamera />
                      </IconButton>
                    </Tooltip>
                  </div>

                  <div style={{}}>
                    <img
                      // defaultValue={volunteerData.voluntary_image}
                      style={{
                        height: "120px",
                        maxWidth: "200px",
                      }}
                      // src={volunteerData.voluntary_image}
                      src={URL.createObjectURL(selectedImageNid)}
                      alt="Thumb"
                    />
                  </div>
                  <div
                    style={{
                      alignItem: "center",
                      justifyContent: "center",
                      marginTop: "1.5rem",
                    }}
                  >
                    <Tooltip title="Remove this image here">
                      <IconButton onClick={removeSelectedImageNid}>
                        <HighlightOffIcon
                          sx={{
                            color: "#3490DC",
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              )}
            </ImageDiv>
          </InputDiv>
        </InputFieldDiv>

        <InputFieldDiv>
          <div>
            <InputDiv>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                  name="dob"
                  control={control}
                  defaultValue={volunteerData?.dob}
                  render={({ field }) => (
                    <>
                      <DesktopDatePicker
                        label="Date of Birth"
                        maxDate={new Date()}
                        inputFormat="DD MMM YYYY"
                        value={field.value}
                        onChange={(date) => field.onChange(date)}
                        renderInput={(params) => (
                          <TextField fullWidth size="small" {...params} />
                        )}
                      />
                      {errors.dob && (
                        <ErrorMessage>{errors.dob.message}</ErrorMessage>
                      )}
                    </>
                  )}
                />
              </LocalizationProvider>
            </InputDiv>

            <InputDiv>
              <TextField
                select
                defaultValue={volunteerData?.sex}
                fullWidth
                size="small"
                label="Sex*"
                {...register("sex", {
                  onChange: (e) => handleFemale(e),
                })}
              >
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
                <MenuItem value="Others">Others</MenuItem>
              </TextField>
            </InputDiv>

            {female === "Female" && (
              <>
                <InputDiv>
                  <TextField
                    size="small"
                    fullWidth
                    label="Father/Husband Name*"
                    variant="outlined"
                    defaultValue={volunteerData?.v_fathr_or_husb_name}
                    {...register("v_fathr_or_husb_name")}
                    error={!!errors.v_fathr_or_husb_name}
                    helperText={errors.v_fathr_or_husb_name?.message}
                  />
                </InputDiv>

                <InputDiv>
                  <StyledInput
                    type="number"
                    size="small"
                    fullWidth
                    label="Father/Husband NID*"
                    variant="outlined"
                    defaultValue={volunteerData?.fathr_or_husb_nid}
                    {...register("fathr_or_husb_nid")}
                    error={!!errors.fathr_or_husb_nid}
                    helperText={errors.fathr_or_husb_nid?.message}
                  />
                </InputDiv>
              </>
            )}

            <InputDiv>
              <TextField
                fullWidth
                size="small"
                id="outlined-select-currency"
                select
                defaultValue={volunteerData?.vol_blood_group}
                label="Blood Group"
                {...register("vol_blood_group", {})}
              >
                <MenuItem
                  style={{ display: "none" }}
                  value={0}
                  selected
                  disabled
                >
                  --select--
                </MenuItem>
                <MenuItem value="O+">O+</MenuItem>
                <MenuItem value="O-">O-</MenuItem>
                <MenuItem value="A+">A+</MenuItem>
                <MenuItem value="A-">A-</MenuItem>
                <MenuItem value="B+">B+</MenuItem>
                <MenuItem value="B-">B-</MenuItem>
                <MenuItem value="AB+">AB+</MenuItem>
                <MenuItem value="AB-">AB-</MenuItem>
                <MenuItem value="Unknown">Unknown</MenuItem>
              </TextField>
            </InputDiv>

            <InputDiv>
              <TextField
                select
                defaultValue={volunteerData?.nationality}
                fullWidth
                size="small"
                label="Nationality*"
                {...register("nationality", {})}
              >
                <MenuItem value="Bangladeshi">Bangladeshi</MenuItem>
                <MenuItem value="Indian">Indian</MenuItem>
                <MenuItem value="American">American</MenuItem>
                <MenuItem value="Australian">Australian</MenuItem>
              </TextField>
            </InputDiv>

            <InputDiv>
              <TextField
                select
                defaultValue={volunteerData?.occupation_name}
                fullWidth
                size="small"
                label="Occupation*"
                {...register("occupation_name", {})}
              >
                {occupationInfo.map((occupation) => (
                  <MenuItem
                    key={Math.random(Number)}
                    value={occupation?.occupation_name}
                  >
                    {occupation?.occupation_name}
                  </MenuItem>
                ))}
              </TextField>
              {errors?.occupation_name?.type === "required" && (
                <ErrorMessage>Occupation name is required</ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <StyledInput
                type="number"
                size="small"
                fullWidth
                label="NID*"
                variant="outlined"
                defaultValue={volunteerData?.national_id}
                {...register("national_id")}
              />
              {errors.national_id && (
                <ErrorMessage>{errors.national_id.message}</ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <StyledInput
                type="number"
                size="small"
                fullWidth
                label="Contact Number*"
                variant="outlined"
                defaultValue={volunteerData?.contact_phone}
                {...register("contact_phone")}
              />
              {errors.contact_phone && (
                <ErrorMessage>{errors.contact_phone.message}</ErrorMessage>
              )}
            </InputDiv>
            <InputDiv>
              <StyledInput
                type="email"
                size="small"
                fullWidth
                label="Email"
                variant="outlined"
                defaultValue={volunteerData?.email}
                {...register("email")}
              />
              {errors.email && (
                <ErrorMessage>{errors.email.message}</ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <StyledInput
                type="number"
                size="small"
                fullWidth
                label="Emergency Contact Number*"
                variant="outlined"
                defaultValue={volunteerData?.emergency_contract_ph}
                {...register("emergency_contract_ph")}
              />
              {errors.emergency_contract_ph && (
                <ErrorMessage>
                  {errors.emergency_contract_ph.message}
                </ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <TextField
                size="small"
                fullWidth
                label="Relative Name"
                variant="outlined"
                defaultValue={volunteerData?.emergency_contract_nm}
                {...register("emergency_contract_nm")}
              />
              {errors.emergency_contract_nm && (
                <ErrorMessage>
                  {errors.emergency_contract_nm.message}
                </ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <TextField
                fullWidth
                size="small"
                id="outlined-select-currency"
                defaultValue={volunteerData?.contact_contract_relation}
                label="Relation with Volunteer*"
                {...register("contact_contract_relation")}
              ></TextField>
              {errors.contact_contract_relation && (
                <ErrorMessage>
                  {errors.contact_contract_relation.message}
                </ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <ImageDivText style={{ padding: "10px 0px 0px 0px" }}>
                Medical History
              </ImageDivText>
            </InputDiv>
            <InputDiv>
              <TextField
                select
                defaultValue={medicalHistorys === "Y" ? "Y" : "N"}
                fullWidth
                size="small"
                label=" Medical History*"
                {...register("medical_history", {
                  onChange: (e) => handleMedicalHistory(e),
                })}
              >
                <MenuItem value="Y">Yes</MenuItem>
                <MenuItem value="N">No</MenuItem>
              </TextField>
            </InputDiv>
            {(isMedicalHistory || medicalHistorys === "Y") && (
              <>
                <>
                  <InputDiv>
                    <TextField
                      size="small"
                      fullWidth
                      label="Health Condition"
                      defaultValue={
                        volunteerData?.health_condition === "undefined"
                          ? ""
                          : volunteerData?.health_condition
                      }
                      variant="outlined"
                      {...register("health_condition")}
                      error={!!errors.health_condition}
                      helperText={errors.health_condition?.message}
                    />
                  </InputDiv>
                </>

                <>
                  <InputDiv>
                    <TextField
                      size="small"
                      fullWidth
                      label="Previous Illnesses"
                      defaultValue={
                        volunteerData?.previous_illness === "undefined"
                          ? ""
                          : volunteerData?.previous_illness
                      }
                      variant="outlined"
                      {...register("previous_illness")}
                      error={!!errors.previous_illness}
                      helperText={errors.previous_illness?.message}
                    />
                  </InputDiv>
                </>

                <>
                  <InputDiv>
                    <TextField
                      size="small"
                      fullWidth
                      label="Surgeries"
                      defaultValue={
                        volunteerData?.surgery_history === "undefined"
                          ? ""
                          : volunteerData?.surgery_history
                      }
                      variant="outlined"
                      {...register("surgery_history")}
                      error={!!errors.surgery_history}
                      helperText={errors.surgery_history?.message}
                    />
                  </InputDiv>
                </>

                <>
                  <InputDiv>
                    <TextField
                      size="small"
                      fullWidth
                      label="Allergies"
                      defaultValue={
                        volunteerData?.allergies === "undefined"
                          ? ""
                          : volunteerData?.allergies
                      }
                      variant="outlined"
                      {...register("allergies")}
                      error={!!errors.allergies}
                      helperText={errors.allergies?.message}
                    />
                  </InputDiv>
                </>

                <>
                  <InputDiv>
                    <TextField
                      size="small"
                      fullWidth
                      label="Current Medications"
                      defaultValue={
                        volunteerData?.curr_medication === "undefined"
                          ? ""
                          : volunteerData?.curr_medication
                      }
                      variant="outlined"
                      {...register("curr_medication")}
                      error={!!errors.curr_medication}
                      helperText={errors.curr_medication?.message}
                    />
                  </InputDiv>
                </>
              </>
            )}
            {/* {(isMedicalHistory || medicalHistorys === "Y") && (
              <>
                <>
                  <InputDiv>
                    <TextField
                      size="small"
                      fullWidth
                      label="Health Condition"
                      defaultValue={
                        volunteerInformationData[0]?.health_condition ===
                        "undefined"
                          ? ""
                          : volunteerInformationData[0]?.health_condition
                      }
                      variant="outlined"
                      {...register("health_condition")}
                      error={!!errors.health_condition}
                      helperText={errors.health_condition?.message}
                    />
                  </InputDiv>
                </>

                <>
                  <InputDiv>
                    <TextField
                      size="small"
                      fullWidth
                      label="Previous Illnesses"
                      defaultValue={
                        volunteerInformationData[0]?.previous_illness ===
                        "undefined"
                          ? ""
                          : volunteerInformationData[0]?.previous_illness
                      }
                      variant="outlined"
                      {...register("previous_illness")}
                      error={!!errors.previous_illness}
                      helperText={errors.previous_illness?.message}
                    />
                  </InputDiv>
                </>

                <>
                  <InputDiv>
                    <TextField
                      size="small"
                      fullWidth
                      label="Surgeries"
                      defaultValue={
                        volunteerInformationData[0]?.surgery_history ===
                        "undefined"
                          ? ""
                          : volunteerInformationData[0]?.surgery_history
                      }
                      variant="outlined"
                      {...register("surgery_history")}
                      error={!!errors.surgery_history}
                      helperText={errors.surgery_history?.message}
                    />
                  </InputDiv>
                </>

                <>
                  <InputDiv>
                    <TextField
                      size="small"
                      fullWidth
                      label="Allergies"
                      defaultValue={
                        volunteerInformationData[0]?.allergies === "undefined"
                          ? ""
                          : volunteerInformationData[0]?.allergies
                      }
                      variant="outlined"
                      {...register("allergies")}
                      error={!!errors.allergies}
                      helperText={errors.allergies?.message}
                    />
                  </InputDiv>
                </>

                <>
                  <InputDiv>
                    <TextField
                      size="small"
                      fullWidth
                      label="Current Medications"
                      defaultValue={
                        volunteerInformationData[0]?.curr_medication ===
                        "undefined"
                          ? ""
                          : volunteerInformationData[0]?.curr_medication
                      }
                      variant="outlined"
                      {...register("curr_medication")}
                      error={!!errors.curr_medication}
                      helperText={errors.curr_medication?.message}
                    />
                  </InputDiv>
                </>
              </>
            )} */}
          </div>

          <div>
            <InputDiv>
              <TextField
                size="small"
                fullWidth
                label="Old Volunteer Id"
                variant="outlined"
                defaultValue={volunteerData?.old_vol_id}
                {...register("old_vol_id", {})}
              />
            </InputDiv>

            <InputDiv>
              <TextField
                select
                size="small"
                fullWidth
                label="PRO Name"
                variant="outlined"
                defaultValue={volunteerData?.pro_id}
                {...register("pro_id", {})}
              >
                {proInfo.map((pro) => (
                  <MenuItem key={Math.random(Number)} value={pro?.pro_id}>
                    {pro?.pro_name}
                  </MenuItem>
                ))}
              </TextField>
            </InputDiv>

            <InputDiv>
              <TextField
                select
                size="small"
                fullWidth
                label="Active Status"
                variant="outlined"
                defaultValue={volunteerData?.active_fg === "1" ? "1" : "0"}
                {...register("active_fg")}
              >
                <MenuItem value="1">Active</MenuItem>
                <MenuItem value="0">Inactive</MenuItem>
              </TextField>
              {errors?.active_fg && (
                <ErrorMessage>{errors.active_fg.message}</ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <ImageDivText style={{ padding: "20px 0px 0px 24px" }}>
                Availability
              </ImageDivText>
            </InputDiv>
            <InputDiv>
              <TextField
                select
                defaultValue={volunteerData?.availability === "Y" ? "Y" : "N"}
                fullWidth
                size="small"
                label="Availability for participation in clinical trials*"
                {...register("availability", {
                  onChange: (e) => handleAvailability(e),
                })}
              >
                <MenuItem value="Y">Yes</MenuItem>
                <MenuItem value="N">No</MenuItem>
              </TextField>
            </InputDiv>
            {(isAvailability || availabilitys) && (
              <>
                <InputDiv>
                  <TextField
                    select
                    defaultValue={
                      volunteerData?.previous_clinic_trial === "Y" ? "Y" : "N"
                    }
                    fullWidth
                    size="small"
                    label="Have you previously participated in clinical trials"
                    {...register("previous_clinic_trial", {
                      onChange: (e) => handleParticipatedClinicalTrials(e),
                    })}
                  >
                    <MenuItem value="Y">Yes</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </TextField>
                </InputDiv>

                {(isParticipatedClinicalTrials ||
                  participatedClinicalTrials === "Y") && (
                  <>
                    <InputDiv>
                      <TextField
                        size="small"
                        fullWidth
                        defaultValue={
                          volunteerData.pre_clin_trial_detail === "undefined"
                            ? ""
                            : volunteerData.pre_clin_trial_detail
                        }
                        label="Please provide details"
                        variant="outlined"
                        {...register("pre_clin_trial_detail")}
                        error={!!errors.pre_clin_trial_detail}
                        helperText={errors.pre_clin_trial_detail?.message}
                      />
                    </InputDiv>
                  </>
                )}
              </>
            )}

            <InputDiv>
              <ImageDivText style={{ padding: "20px 0px 0px 24px" }}>
                Present Address
              </ImageDivText>
            </InputDiv>

            <InputDiv>
              <TextField
                fullWidth
                size="small"
                id="outlined-select-currency"
                select
                defaultValue={volunteerData?.pr_city}
                label="Division"
                onChange={(e) => handleDivision(e)}
              >
                {division.map((division) => (
                  <MenuItem
                    key={Math.random(Number)}
                    value={division?.divsion_id}
                  >
                    {division?.divsion_nm}
                  </MenuItem>
                ))}
              </TextField>
            </InputDiv>

            <InputDiv>
              <TextField
                fullWidth
                size="small"
                id="outlined-select-currency"
                select
                defaultValue={volunteerData?.permanent_district}
                label="District"
                onChange={(e) => handleDistrict(e)}
              >
                {district.map((district) => (
                  <MenuItem
                    key={Math.random(Number)}
                    value={district?.dzila_code}
                  >
                    {district?.dzila_name}
                  </MenuItem>
                ))}
              </TextField>
            </InputDiv>

            <InputDiv>
              <TextField
                fullWidth
                size="small"
                id="outlined-select-currency"
                select
                defaultValue={volunteerData?.thana_id}
                label="Police Station"
                {...register("thana_id", {})}
              >
                {thana.map((thana) => (
                  <MenuItem key={Math.random(Number)} value={thana?.thana_code}>
                    {thana?.thana_name}
                  </MenuItem>
                ))}
              </TextField>
            </InputDiv>

            <InputDiv>
              <TextField
                size="small"
                fullWidth
                label="Post"
                variant="outlined"
                defaultValue={volunteerData?.permanent_postoffice}
                {...register("permanent_postoffice", {})}
              />
            </InputDiv>

            <InputDiv>
              <TextField
                size="small"
                fullWidth
                label="Village"
                variant="outlined"
                defaultValue={volunteerData?.village_name}
                {...register("village_name", {})}
              />
            </InputDiv>
            <InputDiv>
              <ImageDivText style={{ padding: "5px 0px 0px 0px" }}>
                Attachment
              </ImageDivText>
            </InputDiv>
            <InputDiv>
              <Controller
                name="covid"
                control={control}
                defaultValue={
                  volunteerData.first_attachment_type === "C" ? "C" : "N"
                }
                render={({ field }) => (
                  <TextField
                    select
                    {...field}
                    fullWidth
                    label="COVID-19 vaccine card*"
                    size="small"
                  >
                    <MenuItem value="C">Yes</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </TextField>
                )}
                rules={{
                  required: true,
                  onChange: (e) => handleCOVID(e),
                }}
              />
            </InputDiv>
            {(isCOVID || first_attachment_types === "C") && (
              <>
                <InputDiv>
                  <TextField
                    size="small"
                    fullWidth
                    label="COVID-19 Vaccine Card Title*"
                    defaultValue={
                      volunteerData.covid_title === "undefined"
                        ? ""
                        : volunteerData.covid_title
                    }
                    variant="outlined"
                    {...register("covid_title")}
                    error={!!errors.covid_title}
                    helperText={errors.covid_title?.message}
                  />
                </InputDiv>
                <InputDiv>
                  <TextField
                    size="small"
                    fullWidth
                    label="Description*"
                    defaultValue={
                      volunteerData.covid_desc === "undefined"
                        ? ""
                        : volunteerData.covid_desc
                    }
                    variant="outlined"
                    {...register("covid_desc")}
                    error={!!errors.covid_desc}
                    helperText={errors.covid_desc?.message}
                  />
                </InputDiv>

                <ImageDiv
                  style={{
                    height: "160px",
                    margin: "10px 0px 0px 25px",
                  }}
                >
                  {!selectedImageCOVID && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around",
                        width: "100%",
                        gap: ".2rem",
                      }}
                    >
                      <div
                        style={{
                          alignItem: "center",
                          justifyContent: "center",
                          marginTop: "1.5rem",
                        }}
                      >
                        <Tooltip title="Upload image here">
                          <IconButton
                            color="primary"
                            aria-label="upload picture"
                            component="label"
                          >
                            <input
                              hidden
                              accept="image/*"
                              type="file"
                              onChange={imageChangeCOVID}
                            />
                            <PhotoCamera />
                          </IconButton>
                        </Tooltip>
                      </div>

                      <div
                        style={
                          volunteerData?.covid_image
                            ? { display: "block" }
                            : { display: "none" }
                        }
                      >
                        <img
                          style={{
                            height: "120px",
                            maxWidth: "200px",
                          }}
                          src={volunteerData?.covid_image}
                          alt=""
                        />
                      </div>
                    </div>
                  )}

                  {selectedImageCOVID && (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 4fr 1fr",
                        gap: ".2rem",
                      }}
                    >
                      <div
                        style={{
                          alignItem: "center",
                          justifyContent: "center",
                          marginTop: "1.5rem",
                        }}
                      >
                        <Tooltip title="Upload image here">
                          <IconButton
                            color="primary"
                            aria-label="upload picture"
                            component="label"
                          >
                            <input
                              hidden
                              accept="image/*"
                              type="file"
                              onChange={imageChangeCOVID}
                            />
                            <PhotoCamera />
                          </IconButton>
                        </Tooltip>
                      </div>

                      <div style={{}}>
                        <img
                          style={{
                            height: "120px",
                            maxWidth: "200px",
                          }}
                          src={URL.createObjectURL(selectedImageCOVID)}
                          alt="Thumb"
                        />
                      </div>
                      <div
                        style={{
                          alignItem: "center",
                          justifyContent: "center",
                          marginTop: "1.5rem",
                        }}
                      >
                        <Tooltip title="Remove this image here">
                          <IconButton onClick={removeSelectedImageCOVID}>
                            <HighlightOffIcon
                              sx={{
                                color: "#3490DC",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </div>
                  )}
                </ImageDiv>
              </>
            )}
            <InputDiv>
              <Controller
                name="fatherOrHusbandNID"
                control={control}
                defaultValue={
                  volunteerData.second_attachment_type === "F" ? "F" : "N"
                }
                render={({ field }) => (
                  <TextField
                    select
                    {...field}
                    fullWidth
                    label="Father/ Husband NID*"
                    size="small"
                  >
                    <MenuItem value="F">Yes</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </TextField>
                )}
                rules={{
                  onChange: (e) => handleFatherOrHusbandNID(e),
                }}
              />
            </InputDiv>
            {(isFatherOrHusbandNID || second_attachment_types === "F") && (
              <>
                <InputDiv>
                  <TextField
                    size="small"
                    fullWidth
                    label="Father/ Husband NID Title*"
                    defaultValue={
                      volunteerData.fathr_or_husb_nid_title === "undefined"
                        ? ""
                        : volunteerData.fathr_or_husb_nid_title
                    }
                    variant="outlined"
                    {...register("fathr_or_husb_nid_title")}
                    error={!!errors.fathr_or_husb_nid_title}
                    helperText={errors.fathr_or_husb_nid_title?.message}
                  />
                </InputDiv>
                <InputDiv>
                  <TextField
                    size="small"
                    fullWidth
                    label="Description*"
                    defaultValue={
                      volunteerData.fathr_or_husb_nid_desc === "undefined"
                        ? ""
                        : volunteerData.fathr_or_husb_nid_desc
                    }
                    variant="outlined"
                    {...register("fathr_or_husb_nid_desc")}
                    error={!!errors.fathr_or_husb_nid_desc}
                    helperText={errors.fathr_or_husb_nid_desc?.message}
                  />
                </InputDiv>
                <ImageDiv
                  style={{
                    height: "160px",
                    margin: "10px 0px 0px 25px",
                  }}
                >
                  {!selectedImageFatherOrHusbandNID && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around",
                        width: "100%",
                        gap: ".2rem",
                      }}
                    >
                      <div
                        style={{
                          alignItem: "center",
                          justifyContent: "center",
                          marginTop: "1.5rem",
                        }}
                      >
                        <Tooltip title="Upload image here">
                          <IconButton
                            color="primary"
                            aria-label="upload picture"
                            component="label"
                          >
                            <input
                              hidden
                              accept="image/*"
                              type="file"
                              onChange={imageChangeFatherOrHusbandNID}
                            />
                            <PhotoCamera />
                          </IconButton>
                        </Tooltip>
                      </div>

                      <div
                        style={
                          volunteerData.fathr_or_husb_nid_image
                            ? { display: "block" }
                            : { display: "none" }
                        }
                      >
                        <img
                          style={{
                            height: "120px",
                            maxWidth: "200px",
                          }}
                          src={volunteerData.fathr_or_husb_nid_image}
                          alt=""
                        />
                      </div>
                    </div>
                  )}

                  {selectedImageFatherOrHusbandNID && (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 4fr 1fr",
                        gap: ".2rem",
                      }}
                    >
                      <div
                        style={{
                          alignItem: "center",
                          justifyContent: "center",
                          marginTop: "1.5rem",
                        }}
                      >
                        <Tooltip title="Upload image here">
                          <IconButton
                            color="primary"
                            aria-label="upload picture"
                            component="label"
                          >
                            <input
                              hidden
                              accept="image/*"
                              type="file"
                              onChange={imageChangeFatherOrHusbandNID}
                            />
                            <PhotoCamera />
                          </IconButton>
                        </Tooltip>
                      </div>

                      <div style={{}}>
                        <img
                          style={{
                            height: "120px",
                            maxWidth: "200px",
                          }}
                          src={URL.createObjectURL(
                            selectedImageFatherOrHusbandNID
                          )}
                          alt="Thumb"
                        />
                      </div>
                      <div
                        style={{
                          alignItem: "center",
                          justifyContent: "center",
                          marginTop: "1.5rem",
                        }}
                      >
                        <Tooltip title="Remove this image here">
                          <IconButton
                            onClick={removeSelectedImageFatherOrHusbandNID}
                          >
                            <HighlightOffIcon
                              sx={{
                                color: "#3490DC",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </div>
                  )}
                </ImageDiv>
              </>
            )}
          </div>
        </InputFieldDiv>

        <Box
          marginTop="20px"
          style={{
            margin: "1.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
          }}
        >
          {approve && (
            <ApprovedButton
              style={{
                width: "20%",
              }}
              type="button"
              onClick={() => approveMethod()}
            >
              Approve
            </ApprovedButton>
          )}

          {isLoading ? (
            <ThemButton style={{}}>
              <SyncLoader color="#FFFFFF" size={8} />{" "}
            </ThemButton>
          ) : (
            <ThemButton type="submit">Update Volunteer</ThemButton>
          )}
        </Box>

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />
      </form>
    </div>
  );
};

export default VolunteerEdit;

// import React, { useEffect, useState } from "react";
// import { useForm, Controller } from "react-hook-form";
// import {
//   ErrorMessage,
//   ImageDiv,
//   ImageDivText,
//   InputContainer,
//   InputDiv,
//   InputDiv1,
//   InputFieldDiv,
//   InputLevel,
// } from "./Volunteer.style";
// import {
//   Box,
//   IconButton,
//   MenuItem,
//   styled,
//   TextField,
//   Tooltip,
// } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { PhotoCamera } from "@mui/icons-material";
// import HighlightOffIcon from "@mui/icons-material/HighlightOff";
// import { handleEditClose } from "../../redux/Reducer/ModalSlice";
// import { ApprovedButton, ThemButton } from "../Login/Login.style";
// import { useQuery } from "@tanstack/react-query";
// import SyncLoader from "react-spinners/SyncLoader";
// import { toast, ToastContainer, Zoom } from "react-toastify";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import useAllVolunteer from "../../hooks/useAllVolunteer";
// import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from "yup";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// const schema = yup.object().shape({
//   doh: yup
//     .date()
//     .required('Date of history is required')
//     .max(new Date(), 'Date of history must not future date'),
//   study: yup.string().required('Study code is required'),
//   full_name: yup
//     .string()
//     .required('Name is required')
//     .min(3, 'Name must be at least 3 characters long'),
// });

// const StyledInput = styled(TextField)(({ theme }) => ({
//   "input[type=number]": {
//     MozAppearance: "textfield",
//   },
//   "input[type=number]::-webkit-outer-spin-button": {
//     WebkitAppearance: "none",
//     margin: 0,
//   },
//   "input[type=number]::-webkit-inner-spin-button": {
//     WebkitAppearance: "none",
//     margin: 0,
//   },
// }));

// const VolunteerEdit = () => {
//   const dispatch = useDispatch();
//   const [selectedImage, setSelectedImage] = useState();
//   const [isLoading, setIsLoading] = useState();
//   const [selectedImageNid, setSelectedImageNid] = useState();
//   const [reg, setReg] = React.useState();
//   const [birth, setBirth] = React.useState();
//   const [division, setDivision] = useState([]);
//   const [divisionId, setDivisionId] = useState("");
//   const [district, setDistrict] = useState([]);
//   const [districtId, setDistrictId] = useState("");
//   const [thana, setThana] = useState([]);
//   const userId = localStorage.getItem("uI");
//   const user_id = userId - 786;
//   const volunteerData = useSelector((state) => state.Modal.val);

//   const [refetch] = useAllVolunteer();

//   const [female, setFemale] = useState(volunteerData?.sex);

//   const ApproveStatusToggle = useSelector((state) => state.Modal.val1);

//   const handleFemale = (e) => {
//     const selectValue = e.target.value;
//     setFemale(selectValue);
//   };

//   useEffect(() => {
//     const getDivision = async () => {
//       const resDivision = await fetch(
//         `${process.env.REACT_APP_API_URL}/api/divisionList`
//       );
//       const resDiv = await resDivision.json();
//       setDivision(await resDiv);
//     };
//     getDivision();
//   }, []);

//   const handleDivision = (event) => {
//     const getDivisionId = event.target.value;
//     setDivisionId(getDivisionId);
//   };

//   useEffect(() => {
//     const getDistrict = async () => {
//       const resDistrict = await fetch(
//         `${process.env.REACT_APP_API_URL}/api/districtList/${volunteerData.pr_city}`
//       );
//       const resDis = await resDistrict.json();
//       setDistrict(await resDis);
//     };
//     getDistrict();
//   }, []);

//   useEffect(() => {
//     if (divisionId) {
//       const getDistrict = async () => {
//         const resDistrict = await fetch(
//           `${process.env.REACT_APP_API_URL}/api/districtList/${divisionId}`
//         );
//         const resDis = await resDistrict.json();
//         setDistrict(await resDis);
//       };
//       getDistrict();
//     }
//   }, [divisionId]);

//   const handleDistrict = (event) => {
//     const getDistrictId = event.target.value;
//     setDistrictId(getDistrictId);
//   };

//   useEffect(() => {
//     const getThana = async () => {
//       const resThana = await fetch(
//         `${process.env.REACT_APP_API_URL}/api/thanaList/${volunteerData.permanent_district}`
//       );
//       const resTh = await resThana.json();
//       setThana(await resTh);
//     };
//     getThana();
//   }, []);

//   useEffect(() => {
//     if (districtId) {
//       const getThana = async () => {
//         const resThana = await fetch(
//           `${process.env.REACT_APP_API_URL}/api/thanaList/${districtId}`
//         );
//         const resTh = await resThana.json();
//         setThana(await resTh);
//       };
//       getThana();
//     }
//   }, [districtId]);

//   const { data: occupationInfo = [] } = useQuery({
//     queryKey: ["occupationInfo"],
//     queryFn: async () => {
//       const res = await fetch(
//         `${process.env.REACT_APP_API_URL}/api/occupationDropdown`
//       );
//       const data = await res.json();
//       return data;
//     },
//   });

//   const approve =
//     volunteerData.national_id != null &&
//     volunteerData.approved_status === 0 &&
//     volunteerData.national_id != "" &&
//     ApproveStatusToggle !== "1";

//   const approveMethod = () => {
//     fetch(
//       `${process.env.REACT_APP_API_URL}/api/voluntaryApproving/${volunteerData.vol_no}`,

//       {
//         method: "GET",
//       }
//     )
//       .then((res) => {
//         return res.json();
//       })
//       .then((data) => {
//         if (data.success === false && data.age_valid === "low") {
//           toast.error("Not Approve. Volunteer age under 18!", {
//             position: toast.POSITION.TOP_CENTER,
//           });
//         } else if (data.success === false && data.age_valid === "high") {
//           toast.error("Not Approve. Volunteer age over 55!", {
//             position: toast.POSITION.TOP_CENTER,
//           });
//         } else if (data.success === true && data.age_valid === "ok") {
//           dispatch(handleEditClose());
//         }
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       });
//     // .finally(() => setIsLoadingApprove(false));
//   };

//   const {
//     register,
//     control,
//     formState: { errors },
//     handleSubmit,
//   } = useForm({ resolver: yupResolver(schema) });

//   const imageChange = (e) => {
//     if (e.target.files && e.target.files.length > 0) {
//       setSelectedImage(e.target.files[0]);
//     }
//   };

//   const removeSelectedImage = () => {
//     setSelectedImage();
//   };

//   const imageChangeNid = (e) => {
//     if (e.target.files && e.target.files.length > 0) {
//       setSelectedImageNid(e.target.files[0]);
//     }
//   };

//   const removeSelectedImageNid = () => {
//     setSelectedImageNid();
//   };

//   const { data: proInfo = [] } = useQuery({
//     queryKey: ["proInfo"],
//     queryFn: async () => {
//       const res = await fetch(
//         `${process.env.REACT_APP_API_URL}/api/proNameList`
//       );
//       const volData = await res.json();
//       const data = await volData.data;
//       return data;
//     },
//   });

//   const onSubmit = (data, e) => {
//     const reg1 = data?.doh
//     const dateObj = new Date(reg1);
//     const dateStr = dateObj.toLocaleDateString("en-CA");
//     // alert(JSON.stringify(data));
//     setIsLoading(true);
//     const formData = new FormData();
//     formData.append("user_id", user_id);
//     formData.append("vol_no", volunteerData.vol_no);
//     formData.append("voluntary_image", selectedImage);
//     formData.append("voluntary_nid_image", selectedImageNid);
//     formData.append(
//       "date_of_registration",
//       dateStr || volunteerData.date_of_registration
//     );
//     formData.append("full_name", data.full_name);
//     formData.append("vol_initial", data.vol_initial);
//     formData.append("father_name", data.father_name);
//     formData.append("sex", data.sex);
//     formData.append("v_fathr_or_husb_name", data.v_fathr_or_husb_name);
//     formData.append("fathr_or_husb_nid", data.fathr_or_husb_nid);
//     formData.append("mother_name", data.mother_name);
//     formData.append("marital_status", data.marital_status);
//     formData.append("dob", birth || volunteerData.dob);
//     formData.append("vol_blood_group", data.vol_blood_group);
//     formData.append("nationality", data.nationality);
//     formData.append("occupation_name", data.occupation_name);
//     formData.append("national_id", data.national_id);
//     formData.append("contact_phone", data.contact_phone);
//     formData.append("pr_city", divisionId || volunteerData.pr_city);
//     formData.append(
//       "permanent_district",
//       districtId || volunteerData.permanent_district
//     );
//     formData.append("thana_id", data.thana_id);
//     formData.append("permanent_postoffice", data.permanent_postoffice);
//     formData.append("village_name", data.village_name);
//     formData.append("pro_id", data.pro_id);
//     formData.append("old_vol_id", data.old_vol_id);
//     formData.append("emergency_contract_ph", data.emergency_contract_ph);
//     formData.append("emergency_contract_nm", data.emergency_contract_nm);
//     formData.append(
//       "contact_contract_relation",
//       data.contact_contract_relation
//     );
//     formData.append(
//       "reg_no",
//       data.reg_no
//     );
//     formData.append(
//       "active_fg",
//       data.active_fg
//     );
//     fetch(
//       // `${process.env.REACT_APP_API_URL}/api/updateVoluntary`,
//       `${process.env.REACT_APP_API_URL}/api/updateVoluntary`,
//       {
//         method: "POST",
//         body: formData,
//       }
//     )
//       .then((res) => {
//         return res.json();
//       })
//       .then((data) => {
//         if (data.success === true) {
//           dispatch(handleEditClose());
//           refetch();
//         }
//         if (data.success === false) {
//           toast.error("volunteer not update!!", {
//             position: toast.POSITION.TOP_CENTER,
//           });
//         }
//       })
//       .finally(() => setIsLoading(false));
//   };

//   const handleConvertReg = (date) => {
//     const dateObj = date;
//     const isoString = dateObj.toLocaleString();
//     const datePart = isoString.substring(0, 10);
//     setReg(datePart);
//   };

//   const handleConvertDob = (date) => {
//     const dateObj = date;
//     const isoString = dateObj.toLocaleString();
//     const datePart = isoString.substring(0, 10);
//     setBirth(datePart);
//   };

//   return (
//     <div>
//       <form onSubmit={handleSubmit(onSubmit)}>
//         <InputFieldDiv>
//           <InputDiv>
//             <InputContainer style={{ height: "1rem" }}></InputContainer>
//             <InputContainer>
//               <InputLevel>Date of Registration</InputLevel>
//               {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
//                 <DesktopDatePicker
//                   inputFormat="dd MMM yyyy"
//                   value={reg || volunteerData.date_of_registration}
//                   maxDate={new Date()}
//                   onChange={handleConvertReg}
//                   renderInput={(params) => (
//                     <TextField fullWidth size="small" {...params} />
//                   )}
//                 />
//               </LocalizationProvider> */}

//               <LocalizationProvider dateAdapter={AdapterDayjs}>
//                 <Controller
//                   name="doh"
//                   control={control}
//                   defaultValue={volunteerData?.date_of_registration}
//                   render={({ field }) => (
//                     <>
//                       <DesktopDatePicker
//                         label="Date of history"
//                         maxDate={new Date()}
//                         inputFormat="DD MMM YYYY"
//                         value={field.value}
//                         onChange={(date) => field.onChange(date)}
//                         renderInput={(params) => (
//                           <TextField fullWidth size="small" {...params} />
//                         )}
//                       />
//                       {errors.doh && (
//                         <ErrorMessage>{errors.doh.message}</ErrorMessage>
//                       )}
//                     </>
//                   )}
//                 />
//               </LocalizationProvider>
//             </InputContainer>

//             <InputDiv1>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Name*"
//                 variant="outlined"
//                 {...register("full_name")}
//               />
//               {errors.full_name && (
//                 <ErrorMessage>{errors.full_name.message}</ErrorMessage>
//               )}
//               {/* <TextField
//                 size="small"
//                 fullWidth
//                 label="Name*"
//                 variant="outlined"
//                 defaultValue={volunteerData.full_name}
//                 {...register("full_name", {
//                   required: true,
//                   minLength: 3,
//                 })}
//               />
//               {errors?.full_name?.type === "required" && (
//                 <ErrorMessage>Name is required</ErrorMessage>
//               )}
//               {errors?.full_name?.type === "minLength" && (
//                 <ErrorMessage>Name must be 3 digit</ErrorMessage>
//               )} */}
//             </InputDiv1>

//             <InputDiv1>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Registration Number"
//                 variant="outlined"
//                 defaultValue={volunteerData?.reg_no}
//                 {...register("reg_no", {
//                   // required: true,
//                   // minLength: 3,
//                 })}
//               />
//               {errors?.reg_no?.type === "minLength" && (
//                 <ErrorMessage>Name must be 3 digit</ErrorMessage>
//               )}
//             </InputDiv1>

//             <InputDiv1>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Father Name"
//                 variant="outlined"
//                 defaultValue={volunteerData.father_name}
//                 {...register("father_name", {
//                   required: true,
//                   minLength: 3,
//                 })}
//               />
//               {errors?.father_name?.type === "required" && (
//                 <ErrorMessage>Father name is required</ErrorMessage>
//               )}
//               {errors?.father_name?.type === "minLength" && (
//                 <ErrorMessage>Father name must be 3 digit</ErrorMessage>
//               )}
//             </InputDiv1>

//             <InputDiv1>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Mother Name"
//                 defaultValue={volunteerData.mother_name}
//                 variant="outlined"
//                 {...register("mother_name", {
//                   // required: true,
//                 })}
//               />
//               {errors?.mother_name?.type === "required" && (
//                 <ErrorMessage>Mother Name is required</ErrorMessage>
//               )}
//               {errors?.mother_name?.type === "minLength" && (
//                 <ErrorMessage>Mother name must be 3 digit</ErrorMessage>
//               )}
//             </InputDiv1>

//             <InputDiv1>
//               <TextField
//                 select
//                 defaultValue={volunteerData.marital_status}
//                 fullWidth
//                 size="small"
//                 label="Marital Status*"
//                 {...register("marital_status", {
//                   required: true,
//                 })}
//               >
//                 <MenuItem value="Unmarried">Unmarried</MenuItem>
//                 <MenuItem value="Married">Married</MenuItem>
//               </TextField>
//               {/* )}
//                 rules={{ required: true }}
//               /> */}
//               {errors?.marital_status?.type === "required" && (
//                 <ErrorMessage>Marital status is required</ErrorMessage>
//               )}
//             </InputDiv1>

//           </InputDiv>

//           <InputDiv
//             style={{
//               maxHeight: "500px",
//               lineHeight: "21px",
//               padding: "8px 0px 0px 24px",
//             }}
//           >
//             <ImageDivText
//               style={{ padding: "6px 0px 0px 12px", marginBottom: ".75rem" }}
//             >
//               Volunteer image (Upload)
//             </ImageDivText>

//             <ImageDiv
//               style={{
//                 height: "160px",
//               }}
//             >
//               {!selectedImage && (
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-around",
//                     width: "100%",
//                     gap: ".2rem",
//                   }}
//                 >
//                   <div
//                     style={{
//                       alignItem: "center",
//                       justifyContent: "center",
//                       marginTop: "1.5rem",
//                     }}
//                   >
//                     <Tooltip title="Upload image here">
//                       <IconButton
//                         color="primary"
//                         aria-label="upload picture"
//                         component="label"
//                       >
//                         <input
//                           hidden
//                           accept="image/*"
//                           type="file"
//                           onChange={imageChange}
//                         />
//                         <PhotoCamera />
//                       </IconButton>
//                     </Tooltip>
//                   </div>

//                   <div
//                     style={
//                       volunteerData.voluntary_image
//                         ? { display: "block" }
//                         : { display: "none" }
//                     }
//                   >
//                     <img
//                       style={{
//                         height: "120px",
//                         maxWidth: "200px",
//                       }}
//                       src={volunteerData.voluntary_image}
//                       alt=""
//                     />
//                   </div>
//                 </div>
//               )}

//               {selectedImage && (
//                 <div
//                   style={{
//                     display: "grid",
//                     gridTemplateColumns: "1fr 4fr 1fr",
//                     gap: ".2rem",
//                   }}
//                 >
//                   <div
//                     style={{
//                       alignItem: "center",
//                       justifyContent: "center",
//                       marginTop: "1.5rem",
//                     }}
//                   >
//                     <Tooltip title="Upload image here">
//                       <IconButton
//                         color="primary"
//                         aria-label="upload picture"
//                         component="label"
//                       >
//                         <input
//                           hidden
//                           accept="image/*"
//                           type="file"
//                           onChange={imageChange}
//                         />
//                         <PhotoCamera />
//                       </IconButton>
//                     </Tooltip>
//                   </div>

//                   <div style={{}}>
//                     <img
//                       // defaultValue={volunteerData.voluntary_image}
//                       style={{
//                         height: "120px",
//                         maxWidth: "200px",
//                       }}
//                       // src={volunteerData.voluntary_image}
//                       src={URL.createObjectURL(selectedImage)}
//                       alt="Thumb"
//                     />
//                   </div>
//                   <div
//                     style={{
//                       alignItem: "center",
//                       justifyContent: "center",
//                       marginTop: "1.5rem",
//                     }}
//                   >
//                     <Tooltip title="Remove this image here">
//                       <IconButton onClick={removeSelectedImage}>
//                         <HighlightOffIcon
//                           sx={{
//                             color: "#3490DC",
//                           }}
//                         />
//                       </IconButton>
//                     </Tooltip>
//                   </div>
//                 </div>
//               )}
//             </ImageDiv>

//             <ImageDivText
//               style={{ padding: "6px 0px 0px 12px", margin: " .25rem 0" }}
//             >
//               NID/Passport/Birth Certificate Image (Upload)
//             </ImageDivText>

//             <ImageDiv
//               style={{
//                 height: "160px",
//               }}
//             >
//               {!selectedImageNid && (
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-around",
//                     width: "100%",
//                     gap: ".2rem",
//                   }}
//                 >
//                   <div
//                     style={{
//                       alignItem: "center",
//                       justifyContent: "center",
//                       marginTop: "1.5rem",
//                     }}
//                   >
//                     <Tooltip title="Upload image here">
//                       <IconButton
//                         color="primary"
//                         aria-label="upload picture"
//                         component="label"
//                       >
//                         <input
//                           hidden
//                           accept="image/*"
//                           type="file"
//                           onChange={imageChangeNid}
//                         />
//                         <PhotoCamera />
//                       </IconButton>
//                     </Tooltip>
//                   </div>

//                   <div
//                     style={
//                       volunteerData.voluntary_nid_image
//                         ? { display: "block" }
//                         : { display: "none" }
//                     }
//                   >
//                     <img
//                       style={{
//                         height: "120px",
//                         maxWidth: "200px",
//                       }}
//                       src={volunteerData.voluntary_nid_image}
//                       alt=""
//                     />
//                   </div>
//                 </div>
//               )}

//               {selectedImageNid && (
//                 <div
//                   style={{
//                     display: "grid",
//                     gridTemplateColumns: "1fr 4fr 1fr",
//                     gap: ".2rem",
//                   }}
//                 >
//                   <div
//                     style={{
//                       alignItem: "center",
//                       justifyContent: "center",
//                       marginTop: "1.5rem",
//                     }}
//                   >
//                     <Tooltip title="Upload image here">
//                       <IconButton
//                         color="primary"
//                         aria-label="upload picture"
//                         component="label"
//                       >
//                         <input
//                           hidden
//                           accept="image/*"
//                           type="file"
//                           onChange={imageChangeNid}
//                         />
//                         <PhotoCamera />
//                       </IconButton>
//                     </Tooltip>
//                   </div>

//                   <div style={{}}>
//                     <img
//                       // defaultValue={volunteerData.voluntary_image}
//                       style={{
//                         height: "120px",
//                         maxWidth: "200px",
//                       }}
//                       // src={volunteerData.voluntary_image}
//                       src={URL.createObjectURL(selectedImageNid)}
//                       alt="Thumb"
//                     />
//                   </div>
//                   <div
//                     style={{
//                       alignItem: "center",
//                       justifyContent: "center",
//                       marginTop: "1.5rem",
//                     }}
//                   >
//                     <Tooltip title="Remove this image here">
//                       <IconButton onClick={removeSelectedImageNid}>
//                         <HighlightOffIcon
//                           sx={{
//                             color: "#3490DC",
//                           }}
//                         />
//                       </IconButton>
//                     </Tooltip>
//                   </div>
//                 </div>
//               )}
//             </ImageDiv>
//           </InputDiv>
//         </InputFieldDiv>

//         <InputFieldDiv>
//           <div>
//             <InputDiv>
//               <LocalizationProvider dateAdapter={AdapterDateFns}>
//                 <DesktopDatePicker
//                   label="Date of Birth"
//                   inputFormat="dd MMM yyyy"
//                   value={birth || volunteerData.dob}
//                   maxDate={new Date()}
//                   onChange={handleConvertDob}
//                   renderInput={(params) => (
//                     <TextField fullWidth size="small" {...params} />
//                   )}
//                 />
//               </LocalizationProvider>
//               {errors?.name?.type === "required" && (
//                 <ErrorMessage>Date of Birth Id is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 select
//                 defaultValue={volunteerData.sex}
//                 fullWidth
//                 size="small"
//                 label="Sex*"
//                 {...register("sex", {
//                   required: true,
//                   onChange: (e) => handleFemale(e),
//                 })}
//               >
//                 <MenuItem value="Male">Male</MenuItem>
//                 <MenuItem value="Female">Female</MenuItem>
//                 <MenuItem value="Others">Others</MenuItem>
//               </TextField>
//               {errors?.sex?.type === "required" && (
//                 <ErrorMessage>Sex is required</ErrorMessage>
//               )}
//             </InputDiv>

//             {female === "Female" && (
//               <>
//                 <InputDiv>
//                   <TextField
//                     size="small"
//                     fullWidth
//                     label="Father/Husband Name*"
//                     variant="outlined"
//                     defaultValue={volunteerData?.v_fathr_or_husb_name}
//                     {...register("v_fathr_or_husb_name", {
//                       required: true,
//                       minLength: 3,
//                     })}
//                   />
//                   {errors?.v_fathr_or_husb_name?.type === "required" && (
//                     <ErrorMessage>Father/Husband Name is required</ErrorMessage>
//                   )}
//                   {errors?.v_fathr_or_husb_name?.type === "minLength" && (
//                     <ErrorMessage>
//                       Father/Husband Name must be 3 digit
//                     </ErrorMessage>
//                   )}
//                 </InputDiv>

//                 <InputDiv>
//                   <StyledInput
//                     type="number"
//                     size="small"
//                     fullWidth
//                     label="Father/Husband NID*"
//                     variant="outlined"
//                     defaultValue={volunteerData?.fathr_or_husb_nid}
//                     {...register("fathr_or_husb_nid", {
//                       required: true,
//                       maxLength: 20,
//                       minLength: 9,
//                     })}
//                   />
//                   {errors?.fathr_or_husb_nid?.type === "required" && (
//                     <ErrorMessage>Father/Husband NID is required</ErrorMessage>
//                   )}
//                   {errors?.fathr_or_husb_nid?.type === "maxLength" && (
//                     <ErrorMessage>
//                       Father/Husband NID must be between 9-20 digit
//                     </ErrorMessage>
//                   )}
//                   {errors?.fathr_or_husb_nid?.type === "minLength" && (
//                     <ErrorMessage>
//                       Father/Husband NID must be between 9-20 digit
//                     </ErrorMessage>
//                   )}
//                 </InputDiv>
//               </>
//             )}

//             <InputDiv>
//               <TextField
//                 fullWidth
//                 size="small"
//                 id="outlined-select-currency"
//                 select
//                 defaultValue={volunteerData.vol_blood_group}
//                 label="Blood Group"
//                 {...register("vol_blood_group", {})}
//               >
//                 <MenuItem
//                   style={{ display: "none" }}
//                   value={0}
//                   selected
//                   disabled
//                 >
//                   --select--
//                 </MenuItem>
//                 <MenuItem value="O+">O+</MenuItem>
//                 <MenuItem value="O-">O-</MenuItem>
//                 <MenuItem value="A+">A+</MenuItem>
//                 <MenuItem value="A-">A-</MenuItem>
//                 <MenuItem value="B+">B+</MenuItem>
//                 <MenuItem value="B-">B-</MenuItem>
//                 <MenuItem value="AB+">AB+</MenuItem>
//                 <MenuItem value="AB-">AB-</MenuItem>
//                 <MenuItem value="Unknown">Unknown</MenuItem>
//               </TextField>
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 select
//                 defaultValue={volunteerData.nationality}
//                 fullWidth
//                 size="small"
//                 label="Nationality*"
//                 {...register("nationality", {
//                   required: true,
//                 })}
//               >
//                 <MenuItem value="Bangladeshi">Bangladeshi</MenuItem>
//                 <MenuItem value="Indian">Indian</MenuItem>
//                 <MenuItem value="American">American</MenuItem>
//                 <MenuItem value="Australian">Australian</MenuItem>
//               </TextField>
//               {errors?.nationality?.type === "required" && (
//                 <ErrorMessage>Nationality is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 select
//                 defaultValue={volunteerData.occupation_name}
//                 fullWidth
//                 size="small"
//                 label="Occupation*"
//                 {...register("occupation_name", {
//                   required: true,
//                 })}
//               >
//                 {occupationInfo.map((occupation) => (
//                   <MenuItem
//                     key={Math.random(Number)}
//                     value={occupation.occupation_name}
//                   >
//                     {occupation.occupation_name}
//                   </MenuItem>
//                 ))}
//               </TextField>
//               {errors?.occupation_name?.type === "required" && (
//                 <ErrorMessage>Occupation name is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <StyledInput
//                 type="number"
//                 size="small"
//                 fullWidth
//                 label="NID*"
//                 variant="outlined"
//                 defaultValue={volunteerData.national_id}
//                 {...register("national_id", {
//                   required: true,
//                   maxLength: 20,
//                   minLength: 9,
//                 })}
//               />
//               {errors?.national_id?.type === "required" && (
//                 <ErrorMessage>National Id is required</ErrorMessage>
//               )}
//               {errors?.national_id?.type === "maxLength" && (
//                 <ErrorMessage>National Id maximum 20 digit</ErrorMessage>
//               )}
//               {errors?.national_id?.type === "minLength" && (
//                 <ErrorMessage>National Id must be 9 digit</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <StyledInput
//                 type="number"
//                 size="small"
//                 fullWidth
//                 label="Contact Number*"
//                 variant="outlined"
//                 defaultValue={volunteerData.contact_phone}
//                 {...register("contact_phone", {
//                   maxLength: 11,
//                   minLength: 11,
//                   required: true,
//                 })}
//               />
//               {errors?.name?.type === "required" && (
//                 <ErrorMessage>Product Id is required</ErrorMessage>
//               )}
//               {errors?.contact_phone?.type === "maxLength" && (
//                 <ErrorMessage>Phone number maximum 11 digit</ErrorMessage>
//               )}
//               {errors?.contact_phone?.type === "minLength" && (
//                 <ErrorMessage>Phone number must be 11 digit</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <StyledInput
//                 type="number"
//                 size="small"
//                 fullWidth
//                 label="Emergency Contact Number*"
//                 variant="outlined"
//                 defaultValue={volunteerData.emergency_contract_ph}
//                 {...register("emergency_contract_ph", {
//                   required: true,
//                   maxLength: 11,
//                   minLength: 11,
//                 })}
//               />
//               {errors?.emergency_contract_ph?.type === "required" && (
//                 <ErrorMessage>Relative Phone number is required</ErrorMessage>
//               )}
//               {errors?.emergency_contract_ph?.type === "maxLength" && (
//                 <ErrorMessage>
//                   Relative Phone number maximum 11 digit
//                 </ErrorMessage>
//               )}
//               {errors?.emergency_contract_ph?.type === "minLength" && (
//                 <ErrorMessage>
//                   Relative Phone number must be 11 digit
//                 </ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Relative Name"
//                 variant="outlined"
//                 defaultValue={volunteerData.emergency_contract_nm}
//                 {...register("emergency_contract_nm", {
//                   // required: true,
//                   minLength: 3,
//                 })}
//               />
//               {errors?.emergency_contract_nm?.type === "required" && (
//                 <ErrorMessage>Relative Name is required</ErrorMessage>
//               )}
//               {errors?.emergency_contract_nm?.type === "minLength" && (
//                 <ErrorMessage>Relative Name must be 3 digit</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 fullWidth
//                 size="small"
//                 id="outlined-select-currency"
//                 // select
//                 defaultValue={volunteerData.contact_contract_relation}
//                 label="Relation with Volunteer*"
//                 {...register("contact_contract_relation", {
//                   required: true,
//                 })}
//               ></TextField>
//               {errors?.contact_contract_relation?.type === "required" && (
//                 <ErrorMessage>Relation with Volunteer is required</ErrorMessage>
//               )}
//             </InputDiv>
//           </div>

//           <div>
//             <InputDiv>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Old Volunteer Id"
//                 variant="outlined"
//                 defaultValue={volunteerData.old_vol_id}
//                 {...register("old_vol_id", {
//                   // required: true,
//                 })}
//               />
//               {errors?.old_vol_id?.type === "required" && (
//                 <ErrorMessage>Postoffice is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 select
//                 size="small"
//                 fullWidth
//                 label="PRO Name"
//                 variant="outlined"
//                 defaultValue={volunteerData.pro_id}
//                 {...register("pro_id", {
//                   // required: true,
//                 })}
//               >
//                 {proInfo.map((pro) => (
//                   <MenuItem key={Math.random(Number)} value={pro.pro_id}>
//                     {pro.pro_name}
//                   </MenuItem>
//                 ))}
//               </TextField>

//               {errors?.pro_id?.type === "required" && (
//                 <ErrorMessage>Pro name is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>

//               <TextField
//                 select
//                 size="small"
//                 fullWidth
//                 label="Active Status*"
//                 variant="outlined"
//                 defaultValue={volunteerData?.active_fg}
//                 {...register("active_fg", { required: true })}
//               >
//                 <MenuItem value="1">Active</MenuItem>
//                 <MenuItem value="0">Inactive</MenuItem>
//               </TextField>
//               {errors?.active_fg?.type === "required" && (
//                 <ErrorMessage>Active status is required*</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <ImageDivText style={{ padding: "20px 0px 0px 24px" }}>
//                 Present Address
//               </ImageDivText>
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 fullWidth
//                 size="small"
//                 id="outlined-select-currency"
//                 select
//                 defaultValue={volunteerData.pr_city}
//                 label="Division"
//                 onChange={(e) => handleDivision(e)}
//               >
//                 {division.map((division) => (
//                   <MenuItem
//                     key={Math.random(Number)}
//                     value={division.divsion_id}
//                   >
//                     {division.divsion_nm}
//                   </MenuItem>
//                 ))}
//               </TextField>
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 fullWidth
//                 size="small"
//                 id="outlined-select-currency"
//                 select
//                 defaultValue={volunteerData.permanent_district}
//                 label="District"
//                 onChange={(e) => handleDistrict(e)}
//               >
//                 {district.map((district) => (
//                   <MenuItem
//                     key={Math.random(Number)}
//                     value={district.dzila_code}
//                   >
//                     {district.dzila_name}
//                   </MenuItem>
//                 ))}
//               </TextField>
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 fullWidth
//                 size="small"
//                 id="outlined-select-currency"
//                 select
//                 defaultValue={volunteerData.thana_id}
//                 label="Police Station"
//                 {...register("thana_id", {})}
//               >
//                 {thana.map((thana) => (
//                   <MenuItem key={Math.random(Number)} value={thana.thana_code}>
//                     {thana.thana_name}
//                   </MenuItem>
//                 ))}
//               </TextField>
//               {errors?.thana_id?.type === "required" && (
//                 <ErrorMessage>Police Station is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Post"
//                 variant="outlined"
//                 defaultValue={volunteerData.permanent_postoffice}
//                 {...register("permanent_postoffice", {
//                   // required: true,
//                 })}
//               />
//               {errors?.permanent_postoffice?.type === "required" && (
//                 <ErrorMessage>Postoffice is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Village"
//                 variant="outlined"
//                 defaultValue={volunteerData.village_name}
//                 {...register("village_name", {
//                   // required: true,
//                 })}
//               />
//               {errors?.village_name?.type === "required" && (
//                 <ErrorMessage>Village name is required</ErrorMessage>
//               )}
//             </InputDiv>
//           </div>
//         </InputFieldDiv>

//         <Box
//           marginTop="20px"
//           style={{
//             margin: "1.5rem",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "1rem",
//           }}
//         >
//           {approve && (
//             <ApprovedButton
//               style={{
//                 width: "20%",
//               }}
//               type="button"
//               onClick={() => approveMethod()}
//             >
//               Approve
//             </ApprovedButton>
//           )}

//           {isLoading ? (
//             <ThemButton style={{}}>
//               <SyncLoader color="#FFFFFF" size={8} />{" "}
//             </ThemButton>
//           ) : (
//             <ThemButton
//               type="submit"
//             >
//               Update Volunteer
//             </ThemButton>
//           )}
//         </Box>

//         <ToastContainer
//           autoClose={2000}
//           limit={1}
//           transition={Zoom}
//           toastStyle={{ border: "2px solid crimson" }}
//         />
//       </form>
//     </div>
//   );
// };

// export default VolunteerEdit;
